import React, { useEffect } from "react";
import { FullScreenSpinner } from "../../../tabin/components/fullScreenSpinner";
import { useNavigate } from "react-router";
// import { landingPath } from "../../main";

export default () => {
    const navigate = useNavigate();

    useEffect(() => {
        const path = sessionStorage.getItem("authRedirectPath");

        navigate(path ? path : "/", { replace: true });
    }, []);

    return (
        <>
            <FullScreenSpinner show={true} text="Redirecting" />
        </>
    );
};
